/**
 * Reads row data from the common paged API response shape.
 *
 * Use this for endpoints that return rows at `response.data.data`, such as
 * Axios responses consumed by React Query. If the response does not contain an
 * array at that path, an empty array is returned.
 *
 * @param {Object} response The API response object.
 * @returns {Array} The response rows.
 */
export const getResponseRows = (response) => {
    const rows = response?.data?.data;

    return Array.isArray(rows) ? rows : [];
};

/**
 * Reads total row count from the common paged API response shape.
 *
 * Use this for endpoints that return the total at `response.data.total`.
 *
 * @param {Object} response The API response object.
 * @returns {number} The total row count.
 */
export const getResponseTotal = (response) => response?.data?.total || 0;
